import { PROVINCES, STREET_TYPE } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: false,
  openNavMenu: true,
  openNotificationsMenu: false,
  loaderText: null,
  streetType: STREET_TYPE,
  maritalStatus: null,
  profession: null,
  sex: null,
  signType: null,
  provinces: PROVINCES,
  provincesDGT: [],
  provincesData: [],
  mapsText: [],
  // theme: 'test-theme',
  theme: 'default',
  headerLogos: {
    logoFrontLeft: null,
    logoFrontRight: null
  },
  footerLogos: [],
  footerPubli: null,
  disclaimer: null,
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  },
  townsCache: {},
  validatingDocuments: false,
  continueWithSave: false,
  validateFields: false,
  support: {},
  showFilesSigId: null,
  showFilesTypeDocumentText: null,
  showFilesDocuments: null,
  brands: null,
  documentation: null,
  replaceVehicle: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
